import { Helmet } from 'react-helmet-async';

const SecurityHeaders = () => (
  <Helmet>
    <meta http-equiv="X-Content-Type-Options" content="nosniff" />
    <meta name="referrer" content="strict-origin-when-cross-origin" />
    <meta http-equiv="X-Frame-Options" content="DENY" />
    <meta
      http-equiv="Content-Security-Policy"
      content="upgrade-insecure-requests"
    />
    <meta
      http-equiv="Permissions-Policy"
      content="camera=(), microphone=(), geolocation=()"
    />
  </Helmet>
);

export default SecurityHeaders;

